// Add your custom JS here.
jQuery(document).ready(function($) {
	jQuery('.testimonial-slider').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: true,
        speed: 300,
        infinite: false,
        autoplay: false
    });
  jQuery('.case-study-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        speed: 300,
        infinite: false,
        autoplay: false,
        responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  });

  jQuery('.review-slider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    dots: false,
    arrows: false,
    centerMode: true,
    centerPadding: '10%', // Adjust this padding to show half items on the sides
    responsive: [
      {
        breakpoint: 1200,
        settings: {
            slidesToShow: 2,
            centerPadding: '5%' // Adjust this padding to show half items on the sides
        }
    },
      
      {
            breakpoint: 767,
            settings: {
                slidesToShow: 1,
                centerPadding: '0%' // Adjust this padding to show half items on the sides
            }
        }
    ]
});



 
  // jQuery('.slider-for-gallery').slick({
  //       slidesToShow: 3,
  //       slidesToScroll: 1,
  //       arrows: true,
  //       dots: false,
  //       speed: 300,
  //       infinite: false,
  //       autoplay: false
  // });
  jQuery('.slider-for-gallery').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    speed: 300,
    autoplay: false,
    responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

  jQuery('.logo-slider').slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        speed: 5000,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 0,
        centerMode: true,
        cssEase: 'linear',
        initialSlide: 1,
        variableWidth: true,
        responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 650,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1
          }
        }
      ]
  });
  
  jQuery(".search-link").click(function(){
    jQuery(this).toggleClass("active");
  });
  jQuery(window).scroll(function(){
    if (jQuery(window).scrollTop() >= 0) {
      jQuery('#wrapper-navbar').addClass('fixed');
     }
     else {
      jQuery('#wrapper-navbar').removeClass('fixed');
     }
  });
});
